module.exports = __webpack_public_path__ + "static/media/googlePlay.5dad3d27.png";